"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SttDetalhesPaciente", {
  enumerable: true,
  get: function get() {
    return _detalhes["default"];
  }
});
Object.defineProperty(exports, "SttFormBuscaPaciente", {
  enumerable: true,
  get: function get() {
    return _busca["default"];
  }
});
Object.defineProperty(exports, "SttFormCadastroPaciente", {
  enumerable: true,
  get: function get() {
    return _campos["default"];
  }
});
Object.defineProperty(exports, "SttIMC", {
  enumerable: true,
  get: function get() {
    return _imc["default"];
  }
});
Object.defineProperty(exports, "SttModalPaciente", {
  enumerable: true,
  get: function get() {
    return _modal["default"];
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "fieldNames", {
  enumerable: true,
  get: function get() {
    return _fieldNames["default"];
  }
});
Object.defineProperty(exports, "validationSchema", {
  enumerable: true,
  get: function get() {
    return _validationSchema["default"];
  }
});
var _lib = _interopRequireDefault(require("./lib"));
var _validationSchema = _interopRequireDefault(require("./lib/form/validationSchema"));
var _fieldNames = _interopRequireDefault(require("./lib/form/fieldNames"));
var _imc = _interopRequireDefault(require("./lib/imc"));
var _detalhes = _interopRequireDefault(require("./lib/detalhes"));
var _modal = _interopRequireDefault(require("./lib/modal"));
var _campos = _interopRequireDefault(require("./lib/form/campos"));
var _busca = _interopRequireDefault(require("./lib/busca"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/** Componente */
var _default = exports["default"] = _lib["default"];